import PropTypes from 'prop-types';
import React from 'react';
import LazyLoad from 'react-lazy-load';
import Waypoint from 'react-waypoint';

import { optionalAttribute } from 'utils/jsx';

import InlineVideo from 'components/InlineVideo/InlineVideo';

import { videoConfigProps } from 'utils/propTypes';

class PlayOnScrollVideo extends React.Component {
  constructor() {
    super();
    this.state = {
      hasVideoPlayed: false,
      isVideoVisible: false,
    };
    this.setVideoEl = this.setVideoEl.bind(this);
    this.onVideoVisible = this.onVideoVisible.bind(this);
  }

  setVideoEl() {
    this.videoEl = this.containerEl.querySelector(`video`);

    if (this.state.isVideoVisible) {
      this.playVideo();
    }
  }

  playVideo() {
    if (!this.videoEl || !this.videoEl.readyState || this.state.hasVideoPlayed) {
      return;
    }

    this.videoEl.play();
    this.setState({ hasVideoPlayed: true });
  }

  onVideoVisible() {
    this.setState({ isVideoVisible: true });
    this.playVideo();
  }

  render() {
    const containerClass = optionalAttribute(`className`, this.props.containerClass, this.props.containerClass);
    const videoClass = optionalAttribute(`className`, this.props.videoClass, this.props.videoClass);
    const offset = optionalAttribute(`offset`, this.props.offset, this.props.offset);

    return (
      <Waypoint
        bottomOffset={this.props.waypointOffset}
        onEnter={this.onVideoVisible}
      >
        <div
          ref={(el) => { this.containerEl = el; }}
          {...containerClass}
        >
          <LazyLoad
            debounce={false}
            onContentVisible={this.setVideoEl}
            {...offset}
          >
            <InlineVideo
              imageDescription={this.props.videoDescription}
              videoConfig={this.props.videoConfig}
              {...videoClass}
            />
          </LazyLoad>
        </div>
      </Waypoint>
    );
  }
}

PlayOnScrollVideo.defaultProps = {
  waypointOffset: `20%`,
};

PlayOnScrollVideo.propTypes = {
  containerClass: PropTypes.string,
  offset: PropTypes.number,
  videoClass: PropTypes.string,
  videoConfig: videoConfigProps,
  videoDescription: PropTypes.string,
  waypointOffset: PropTypes.string,
};

export default PlayOnScrollVideo;
